import { useUserIpInfo as useCoreUserIpInfo } from '@funkit/connect-core'

import { useFunkitIdentity } from '../identity/IdentityContext'
import { logger } from '../logging/logger'

// Re-exported so existing RN importers (isCountryBlocked, the flow hooks, tests)
// keep their type source unchanged after the fetch logic moved to core.
export type {
  FunkitUserIpInfo,
  UseUserIpInfoResult,
} from '@funkit/connect-core'

// Thin RN wrapper over the shared core `useUserIpInfo` (V1 PR13 moved the
// Moonpay→ipapi fetch logic there so web and RN don't duplicate it). RN is
// login-agnostic, so the lookup always runs (`enabled: true`); web's wrapper
// gates on `isUserLoggedIn` instead. `apiKey` lets the core hook reach the
// first-party geo endpoint; the chain it picks is Statsig-driven.
export function useUserIpInfo() {
  const { apiKey } = useFunkitIdentity()

  // Login-agnostic + session-stable: always run, never go stale. The fiat
  // rail prices a US buyer by state, so a stateless answer is worth a second
  // provider here; web reads only the country and leaves this off.
  return useCoreUserIpInfo({
    logger,
    apiKey,
    enabled: true,
    staleTime: Number.POSITIVE_INFINITY,
    requireState: true,
  })
}
